export default __webpack_public_path__ + "images/avatar.png?f51f8dd4ba19d3d0f3ad779749693dc2";